import React, { useContext, useEffect, useState } from "react";
import SsoStackedBarchart from "../../components/Graph/Barchart/SsoStackedBarchart";
import SsoAvgTat from "../../components/Table/SsoAvgTat";
import { axInstBasic } from "../../components/Service/Service";
import { useQuery } from "@tanstack/react-query";
import { FilterContext } from "../../context/Filter";

// Fecth functions
export const fetchSsoAdhereanceData = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}ssoAdhereance`,
      { parArn, childArn }
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// 2.
export const fetchSsoAvgTatData = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}ssoAvgTat`,
      { parArn, childArn }
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const SsoAnalisys = () => {
  // const urlParams = new URLSearchParams(window.location.search);
  // const parArn = urlParams.get("arn");
  // const childArn = urlParams.get("childArn");
  const { superArn: parArn, childArn } = useContext(FilterContext);
  const [selectedMonth, setSelectedMonth] = useState("");
  const { open } = useContext(FilterContext); // ✅ move inside function body

  //   console.log("ParArn", parArn, "ChildArn", childArn);

  const { data: ssoAdhereanceData } = useQuery({
    queryKey: ["ssoAdhereance", parArn, childArn],
    queryFn: () => fetchSsoAdhereanceData(parArn, childArn),
    enabled: !!(parArn || childArn),
  });

  const { data: ssoAvgTatData } = useQuery({
    queryKey: ["ssoAvgTat", parArn, childArn],
    queryFn: () => fetchSsoAvgTatData(parArn, childArn),
    enabled: !!(parArn || childArn),
  });

  useEffect(() => {
    const getCurrentMonth = () => {
      const date = new Date();
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      // If it's the 1st of the month, show previous month
      if (date.getDate() === 1) {
        const prevMonthIndex = (date.getMonth() - 1 + 12) % 12;
        return monthNames[prevMonthIndex];
      }

      // Otherwise, show current month
      return monthNames[date.getMonth()];
    };

    setSelectedMonth(getCurrentMonth());
  }, []);

  return (
    <div className="flex flex-col gap-4 p-2">
      <p className={`w-96 md:w-full ${open ? 'w-[1000px]' : 'w-full'} bg-[#056DB3] text-md rounded-t-md pl-2 p-1 text-white font-semibold`}>
        TAT-Trend Analysis
      </p>
      <div className={` w-96  md:w-full flex flex-col ${open ? '' : 'items-center'} gap-2`}>
        {/* <div className={` w-96 md:${open ? 'w-[1000px]' : 'w-[1200px]'}  border rounded-t-md `}> */}
        <div
          className={`
    w-96
    ${open ? "md:w-[1000px]" : "md:w-[1200px]"}
    border rounded-t-md
  `}
        >

          <p className="text-white bg-[#056DB3] text-md pl-2 p-1 rounded-t-md ">
            SSO Wise Adherence % - ({selectedMonth})
          </p>
          <SsoStackedBarchart data={ssoAdhereanceData} />
        </div>
        <div
          className={`
    w-96 
    border rounded-t-md 
    p-4
    ${open ? "md:w-[1000px]" : "md:w-[1200px]"}
  `}
        >
          <p className="text-white bg-[#056DB3]  text-md pl-2 p-1 rounded-t-md">
            SSO Wise Avg TAT for NC - ({selectedMonth})
          </p>
          <SsoAvgTat data={ssoAvgTatData} />
        </div>
      </div>
    </div>
  );
};

export default SsoAnalisys;
